import {videoPlayerSettings} from '../../../bps/components/videoPlayer/videoPlayerSettings';

videoPlayerSettings.color = 'd4b78b';

export {videoPlayerSettings};
